
import { Group } from '../../types';
import { supabase, getCurrentUserId } from '../../supabase';
import { getGroups, setGroups } from './core';
import { handleApiError } from './api-utils';

export const updateGroup = async (updatedGroup: Group): Promise<boolean> => {
  try {
    const userId = await getCurrentUserId();
    if (!userId) {
      handleApiError(
        new Error('No user ID'), 
        'updateGroup', 
        'User not authenticated when updating group'
      );
      return false;
    }

    const groups = getGroups();
    setGroups(
      groups.map((group) => 
        group.id === updatedGroup.id ? updatedGroup : group
      )
    );

    const { error } = await supabase
      .from('groups')
      .update({
        name: updatedGroup.name,
        description: updatedGroup.description,
        updated_at: new Date().toISOString(),
      })
      .eq('id', updatedGroup.id)
      .eq('user_id', userId);

    if (error) {
      handleApiError(error, 'updateGroup', 'Error updating group in Supabase');
      return false;
    }

    try {
      const { error: deleteError } = await supabase
        .from('product_groups')
        .delete()
        .eq('group_id', updatedGroup.id);

      if (deleteError) {
        handleApiError(deleteError, 'updateGroup', 'Error deleting product-group relationships');
      }

      if (updatedGroup.productIds.length > 0) {
        const productGroups = updatedGroup.productIds.map(productId => ({
          product_id: productId,
          group_id: updatedGroup.id
        }));

        const { error: pgError } = await supabase
          .from('product_groups')
          .insert(productGroups);

        if (pgError) {
          handleApiError(pgError, 'updateGroup', 'Error adding updated product-group relationships');
        }
      }
    } catch (e: any) {
      handleApiError(e, 'updateGroup', 'Error updating group relationships');
      // Continue despite relationship errors
    }

    return true;
  } catch (error: any) {
    handleApiError(error, 'updateGroup', 'Error in updateGroup');
    return false;
  }
};
